export default __webpack_public_path__ + "static/media/obj.29f929a1.svg";